export default __webpack_public_path__ + "static/media/individualServo.f2704554.svg";